import React, { useEffect } from "react";
import "../../App.css";
import { useApp } from '../../core/context';
import { routeFromNotification, notificationVisual, dismissNotification, mapNotif } from '../../core/helpers';
import { isNativeApp } from '../../core/platform';
import { sb } from '../../core/db';
import { Icon, InlineIcon } from '../../components/Icon';
import { NotificationRow } from '../../components/NotificationRow';

function NotificationsPage({ notifications, setNotifications, userId }) {
  const { setView, openModal, user, tasks, submissions, invoices, setNotifFocus } = useApp();
  const belongs = (n) => !userId || !n.userId || n.userId === userId;
  const myNotifs = notifications.filter(belongs);
  const nativeBackView = user?.role === "client" ? "client-home"
    : user?.role === "employee" ? "emp-dashboard"
    : "dashboard";
  const nativeBackLabel = user?.role === "client" ? "My Companies" : "Back";

  useEffect(() => {
    if (!userId) return;
    sb.select('notifications', `user_id=eq.${userId}`)
      .then((rows) => {
        setNotifications(
          (Array.isArray(rows) ? rows : [])
            .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))
            .map(mapNotif),
        );
      })
      .catch(() => {});
  }, [userId, setNotifications]);
  const unread = myNotifs.filter(n => !n.read).length;

  const markRead = (id) => {
    setNotifications(ns => ns.map(n => n.id === id ? { ...n, read: true } : n));
    sb.update("notifications", "id", id, { read: true }).catch(() => {});
  };

  const openNotif = (n) => {
    markRead(n.id);
    routeFromNotification(n, { setView, openModal, user, tasks, submissions, invoices, setNotifFocus });
  };

  const dismissNotif = (id) => dismissNotification(id, setNotifications);

  const markAll = () => {
    sb.markAllNotificationsRead(userId).catch(() => {});
    setNotifications(ns => ns.map(n => n.userId === userId ? { ...n, read: true } : n));
  };

  return (
    <>
      {isNativeApp() && (
        <button className="btn" style={{ marginBottom: 16 }} onClick={() => setView(nativeBackView)}>
          <InlineIcon name="back" size={13} gap={5}>{nativeBackLabel}</InlineIcon>
        </button>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: "var(--muted)" }}>{unread} unread notification{unread !== 1 ? "s" : ""}</div>
        {unread > 0 && <button className="btn btn-sm" onClick={markAll}>Mark all as read</button>}
      </div>
      <div className="card" style={{ overflow: "hidden" }}>
        {myNotifs.length === 0 && (
          <div className="empty"><div className="empty-icon"><Icon name="bell" size={30} /></div><div>No notifications yet</div></div>
        )}
        {myNotifs.map(n => {
          const vis = notificationVisual(n.type);
          return (
            <NotificationRow
              key={n.id}
              className={`row-item notif-list-item${n.read ? "" : " unread"}`}
              onOpen={() => openNotif(n)}
              onDismiss={() => dismissNotif(n.id)}
            >
              <div style={{ width: 36, height: 36, borderRadius: 10, background: vis.bg, color: vis.color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name={vis.icon} size={16} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: n.read ? 400 : 600 }}>{n.title}</div>
                <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 2 }}>{n.body}</div>
                <div style={{ fontSize: 10, color: "var(--faint)", marginTop: 4 }}>{n.time}</div>
              </div>
              {!n.read && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--blue)", flexShrink: 0 }} />}
            </NotificationRow>
          );
        })}
      </div>
    </>
  );
}

export { NotificationsPage };
